<div class="row page-not-found-header-spacer">
  <div class="col center c-info">
    <fa-icon
      [icon]="faSearch"
      size="6x"
      class="u-color--extra-light"></fa-icon>
    <h2 class="u-mt--medium">{{ "notfound.title" | translate }}</h2>
    <h5 class="u-mt--medium">{{ "notfound.description" | translate }}</h5>
    <div class="c-info__item u-mt--large">
      {{ "notfound.goto" | translate }}
      <a routerLink="{{ routeNameConstants.ROOT }}">{{ "notfound.homepage" | translate }}</a>
    </div>
  </div>
</div>
